import React, { useState, useEffect } from 'react';

const PopupConfirmPaymentOption = ({ showPopup, closeAction, confirmAction, paymentType }) => {
  const [isConfirmButtonDisabled, setIsConfirmButtonDisabled] = useState(true);
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (showPopup) {
      setIsConfirmButtonDisabled(true);
      setCountdown(3);

      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            setIsConfirmButtonDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        clearInterval(countdownInterval);
      };
    } else {
      setIsConfirmButtonDisabled(true);
      setCountdown(3);
    }
  }, [showPopup]);

  const getPaymentChoiceText = () => {
    if (paymentType === "single") {
      return "Régler en une seule fois";
    } else if (paymentType === "multiple") {
      return "Régler en deux fois (sans frais)";
    }
    return "";
  };

  return (
    <div className={`project-step-payment__popup pop-up-base-style ${showPopup ? 'active' : ""}`}>
      <div className={"pop-up-simple center"}>
        <img 
          className={"pop-up-simple-cross"} 
          src={"/images/pictos/cross-close.svg"} 
          alt={"cross"} 
          onClick={closeAction} 
        />
        <img 
          className={"pop-up-simple-img"} 
          src='/images/medias/popup.svg' 
          alt='popup forms' 
        />
        <p className={"text-primary color-primary"} style={{ marginBottom: "25px" }}>
          Vous avez choisi : <strong>{getPaymentChoiceText()}</strong>
        </p>
        <p className={"text-primary color-primary"}>
          Attention, votre choix de méthode de paiement est définitif et ne pourra pas être modifié par la suite. Êtes-vous sûr de votre choix ?
        </p>
        <div className={"pop-up-simple-btns"}>
          <button className={"btn-default btn-cancel"} onClick={closeAction}>
            Annuler
          </button>
          <button 
            className={`btn-default ${isConfirmButtonDisabled ? 'btn-disabled' : 'btn-valid'}`}
            onClick={confirmAction}
            disabled={isConfirmButtonDisabled}
          >
            {isConfirmButtonDisabled ? `Confirmer (${countdown}s)` : 'Confirmer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupConfirmPaymentOption;

